export default "__VITE_ASSET__G00RRtUq__"